@use '@shared/styles/media' as media;

.page-no-access-block {
  padding: 4rem 0 4rem 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.no-access-block {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 17rem;
  height: 17rem;
  margin-bottom: 2rem;
  border-radius: 50%;
  background-color: var(--tg-theme-button-color);

  i {
    font-size: 14rem;
    color: var(--tg-theme-button-text-color);
    text-shadow: var(--default-text-shadow);
  }
}

@media (max-width: media.$maxWidthTablet) {
  .no-access-block {
    i {
      font-size: 14rem;
    }
  }
}

@media (max-width: media.$maxWidthPhoneRotated) {
  .page-no-access-block {
    p {
      text-align: center;
    }
  }

  .no-access-block {
    width: 12.5rem;
    height: 12.5rem;
    i {
      font-size: 9rem;
    }
  }
}
